import { CognitoUserPool } from 'amazon-cognito-identity-js';
import appConfig from '../Config/appConfig';

const poolData = {
    UserPoolId: appConfig.cognito.USER_POOL_ID,
    ClientId: appConfig.cognito.APP_CLIENT_ID,
};

export default new CognitoUserPool(poolData);